import { render, staticRenderFns } from "./points-used-record.vue?vue&type=template&id=aad72006&scoped=true"
import script from "./points-used-record.vue?vue&type=script&lang=js"
export * from "./points-used-record.vue?vue&type=script&lang=js"
import style0 from "./points-used-record.vue?vue&type=style&index=0&id=aad72006&prod&scoped=true&lang=css"
import style1 from "./points-used-record.vue?vue&type=style&index=1&id=aad72006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad72006",
  null
  
)

export default component.exports